











import Vue from 'vue';

export default Vue.extend({
	name: 'DmsTableColumn',
	props: {
		label: { type: String },
		prop: { type: String },
		width: { type: String },
		className: { type: String },
		showToolTip: { type: Boolean, default: false}
	},
});
